export default {
  root: (process.env.NODE_ENV !== 'production' || window.location.href.indexOf('admin.scrm.developer.eub-inc.com') > 0) ? 'http://admin.scrm.developer.eub-inc.com/index.php' : window.location.protocol + '//' + window.location.hostname + '/index.php',
  // root: window.location.protocol + '//' + window.location.hostname + '/index.php',
  // root: 'http://admin.scrm.inserv.com.cn/index.php',
  // root: 'http://admin.scrm.developer.eub-inc.com/index.php',
  token_key: 'isv_web_token',
  current_key: 'isv_web_current',
  dateRange: 180
}
